var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2797_46877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5088 0C26.6456 0 29.9999 3.35347 30 7.49023V22.5098C29.9999 26.6465 26.6456 30 22.5088 30H7.49023C3.35345 30 0.000106178 26.6465 0 22.5098V7.49023C0.000105665 3.35347 3.35345 0 7.49023 0H22.5088ZM15.1416 6.30078C10.3264 6.30078 6.2627 10.0266 6.2627 14.9795C6.26272 17.0532 6.64641 18.4844 6.98438 19.7695C7.26806 20.8125 7.51849 21.7679 7.51855 22.8984C7.63956 24.4047 10.4136 23.5249 11.29 22.3984C12.6753 23.3999 13.4726 23.6504 15.1875 23.6504C19.9281 23.6251 23.7534 19.766 23.7373 15.0254C23.7373 10.2102 19.9609 6.30083 15.1416 6.30078ZM15.2588 10.5811V10.5859C17.6886 10.7254 19.5586 12.7848 19.4639 15.2168C19.3007 17.6439 17.2247 19.4938 14.7949 19.377C14.0344 19.3159 13.3035 19.0557 12.6758 18.6221C12.2961 19.0018 11.6863 19.494 11.4443 19.4355C10.9395 19.3012 10.347 16.7357 10.6807 14.6289C11.0854 12.0836 12.9138 10.4601 15.2588 10.5811Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2797_46877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMax);
export default __webpack_public_path__ + "static/media/max.00862424.svg";
export { ForwardRef as ReactComponent };